import { validatePeriodSearch } from '../report-period'
import type { ReportPeriodSearch } from '../report-period'
import type { CareLogActivityType } from '@/lib/api/care-logs-api'
import { ACTIVITY_TYPES } from '@/routes/_app/_authed/_sidebar/agriculture/-care-log-edit-shared'

/** Mọi loại hoạt động, gồm cả Trồng dặm (không cho chọn mới nhưng còn bản ghi cũ). */
export const CARE_ACTIVITIES: CareLogActivityType[] = [
    ...ACTIVITY_TYPES,
    'replanting',
]

/** Bộ lọc báo cáo nhật ký chăm sóc: kỳ + loại hoạt động + tìm hộ. */
export interface CareLogReportSearch extends ReportPeriodSearch {
    activity?: CareLogActivityType
    q?: string
}

export function validateCareLogReportSearch(
    raw: Record<string, unknown>,
): CareLogReportSearch {
    return {
        ...validatePeriodSearch(raw),
        // Báo cáo này không có biểu đồ.
        display: 'report',
        activity: CARE_ACTIVITIES.find((a) => a === raw.activity),
        q: typeof raw.q === 'string' && raw.q.trim() ? raw.q : undefined,
    }
}
